import { render, staticRenderFns } from "./application-widget-container.vue?vue&type=template&id=69dcb564&scoped=true"
import script from "./application-widget-container.vue?vue&type=script&lang=ts"
export * from "./application-widget-container.vue?vue&type=script&lang=ts"
import style0 from "./application-widget-container.vue?vue&type=style&index=0&id=69dcb564&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dcb564",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69dcb564')) {
      api.createRecord('69dcb564', component.options)
    } else {
      api.reload('69dcb564', component.options)
    }
    module.hot.accept("./application-widget-container.vue?vue&type=template&id=69dcb564&scoped=true", function () {
      api.rerender('69dcb564', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/application-widget/components/application-widget-container.vue"
export default component.exports